import { Injectable } from '@angular/core';
import { AuthService } from '@core/services/authentication/auth.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap, map, catchError, of, switchMap } from 'rxjs';
import * as authActions from './auth.actions';
import { LocalStorageService } from '@core/services/local-storage.service';
import { User } from '@core/interfaces/user.model';
import { GtmEventService } from '@core/analytics/gtm-events.service';
import { environment } from '@env/environment';
@Injectable()
export class authEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly _authService: AuthService,
    private readonly _localStorageService: LocalStorageService,
    private readonly _gtmEventService: GtmEventService
  ) {}

  readonly login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(authActions.logIn),
      switchMap(({ data }) => {
        return this._authService
          .login({ username: data.username, password: data.password })
          .pipe(
            map((user: User) => {
              if (user) {
                const response = {
                  ...user,
                  type: data.type,
                };
                const appVersion = environment.appVersion;
                localStorage.setItem('appVersion', appVersion);
                this._authService.setUser(response);
                return authActions.setUser({ user: response });
              }
              return authActions.logInError({ payload: '201' });
            }),
            catchError((error: Error) => {
              return of(authActions.logInError({ payload: error }));
            })
          );
      }),
      tap(() => {
        this._gtmEventService.loginEvent();
      })
    )
  );
}
